import { Button, Flex, Grid, Icon, Text } from '@chakra-ui/react';
import Info from '@ui/components/Info';
import {
  ModalOrDrawerBodyWithMask,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';
import { ArrowForward } from '@veno-app/icons';
import React from 'react';

import StakeCruiserCard from '../GardenNftDrawersShared/StakeCruiserCard';
import {
  STEP,
  useGardenNftDrawerStore,
} from '../GardenNftDrawersShared/useGardenNftDrawer';
import useDoStakeNfts from './useDoStakeNfts';
import useStakeNftInfo from './useStakeNftInfo';

function ConfirmContent() {
  const t = useTranslations();
  const { setStep, selectedTokens } = useGardenNftDrawerStore();
  const { mutate: doStake } = useDoStakeNfts();
  const {
    nfts: cruisers,
    currentNftBoost,
    numberOfStakedCruisers,
  } = useStakeNftInfo();
  const selectedCruisers = cruisers?.filter((c) =>
    selectedTokens.map((token) => token.id).includes(c.tokenId),
  );
  const boostIncrease = selectedCruisers
    ?.map((c) => c.multiplier ?? 1)
    .reduce((prev, c) => c + prev, 0);

  return (
    <>
      <ModalOrDrawerBodyWithMask>
        <Text mx="auto" maxW="300px" textStyle="h3" textAlign="center">
          {t('{coin} selected', {
            coin: 'NFTs',
          })}
        </Text>
        <Grid
          mx="auto"
          mt={6}
          mb={2}
          maxW="min-content"
          rowGap={4}
          columnGap={5}
          templateColumns={`repeat(${Math.min(
            selectedCruisers?.length || 1,
            3,
          )}, 1fr)`}
        >
          {selectedCruisers?.map((c) => (
            <StakeCruiserCard
              key={c.tokenId}
              active={true}
              p="8px 8px 16px"
              {...c}
            />
          ))}
        </Grid>
        <Flex mt={6} gap={4} flexDir="column">
          <Info
            title={t('No of NFTs selected')}
            value={
              numberOfStakedCruisers !== undefined ? (
                <Flex align="center">
                  {numberOfStakedCruisers}{' '}
                  <Icon as={ArrowForward} mx={1} w="15px" h="15px" />
                  <Text as="span" color="garden.highlight">
                    {(numberOfStakedCruisers ?? 0) + selectedTokens.length} / 5
                  </Text>
                </Flex>
              ) : undefined
            }
          />
          <Info
            title={t('Total boost')}
            value={
              boostIncrease && currentNftBoost !== undefined ? (
                <Flex align="center">
                  +{currentNftBoost.toFixed(3)}x
                  <Icon as={ArrowForward} mx={1} w="15px" h="15px" />
                  <Text as="span" color="garden.highlight">
                    +{(boostIncrease + currentNftBoost)?.toFixed(3)}x
                  </Text>
                </Flex>
              ) : undefined
            }
          />
          {/* <Info
            title="Boost multiplier"
            value={
              boostIncrease && currentNftBoost && multFromLocked
                ? `${(currentNftBoost + multFromLocked - 1).toFixed(3)}x > ${(
                    currentNftBoost +
                    multFromLocked -
                    1 +
                    boostIncrease
                  ).toFixed(3)}x`
                : undefined
            }
          /> */}
        </Flex>
      </ModalOrDrawerBodyWithMask>
      <ModalOrDrawerFooter>
        <Button
          onClick={() => {
            setStep(STEP.pending);
            doStake();
          }}
          disabled={!selectedTokens.length}
        >
          {t('Confirm')}
        </Button>
      </ModalOrDrawerFooter>
    </>
  );
}

export default ConfirmContent;
